import SmoothScroll from 'smooth-scroll';
import UsersFilter from 'modules/components/Event/AkiyaKatsuyou/UsersFilter.vue';
import UsersList from 'modules/components/Event/AkiyaKatsuyou/UsersList.vue';
import EventListener from 'modules/mixins/eventListener';

export default class AkiyaKatsuyouList {
  constructor() {
    this.el = '.vue-AkiyaKatsuyouList';
    this.initialize();
  }

  initialize() {
    const { el } = this;
    new Vue({
      el,
      name: 'AkiyaKatsuyouList',
      components: {
        UsersFilter,
        UsersList,
      },
      mixins: [EventListener],
      data() {
        return {
          users: [],
          usersData: [],
          areas: [],
          selectedArea: '',
          isReady: false,
        };
      },
      computed: {
        filteredUsersData() {
          if (!this.selectedArea) {
            return this.usersData;
          }
          return this.usersData.filter((ud) => ud.areas.includes(this.selectedArea) || ud.areas.includes('どこでも！'));
        },
        filteredUsers() {
          return this.users.filter(
            (u) => this.filteredUsersData.findIndex((ud) => ud.id === u.id) > -1,
          );
        },
        filteredUsersId() {
          return this.filteredUsersData.map((ud) => ud.id);
        },
      },
      watch: {
        filteredUsersId() {
          this.filterDetail();
        },
      },
      mounted() {
        this.users = window.__INITIAL_STATE__.users;
        this.usersData = window.__INITIAL_STATE__.usersData;
        this.isReady = true;
        this.handleVisibleReturn();
        this.$listen(window, 'scroll', this.handleVisibleReturn);
      },
      methods: {
        handleFilter(value) {
          this.selectedArea = value;
        },
        filterDetail() {
          const arr = Array.from(document.querySelector('.js-filter-users').querySelectorAll('.js-filter-user'));
          arr.forEach((detail) => {
            if (this.filteredUsersId.includes(Number(detail.getAttribute('key')))) {
              detail.removeAttribute('disabled');
            } else {
              detail.setAttribute('disabled', '');
            }
          });
        },
        handleVisibleReturn() {
          const rect = this.$el.getBoundingClientRect();
          if (rect.bottom > -100) {
            this.$refs.return.setAttribute('disabled', '');
          } else {
            this.$refs.return.removeAttribute('disabled');
          }
        },
        scrollToList() {
          const scroll = new SmoothScroll();
          const anchor = document.querySelector('#list');
          scroll.animateScroll(anchor);
        },
      },
    });
  }
}
